import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { PaymentReceiptService } from '../../../services/payment-receipt.service';
import { gridPageRequest } from '../../../model/common/common.model';

@Component({
  selector: 'app-payment-collections-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './payment-collections-lookup.component.html',
  styleUrl: './payment-collections-lookup.component.scss'
})
export class PaymentCollectionsLookupComponent implements OnInit{

  constructor(private paymentService: PaymentReceiptService,private config: DynamicDialogConfig,private messageService: MessageService) { }

  list: any[] = [];
  
  selectedStatus: any;
  CustomerCode: any;

  pageRequest: gridPageRequest = {
    pageIndex: 1,
    pageSize: 20,
    id: 0
  }

  ngOnInit(): void {
    this.selectedStatus = { name: 'All' };
    this.CustomerCode = this.config.data?.Customer;
    this.getPaymentCollection();
  }

  Status: any[] = [
    { name: 'All' },
    { name: 'Open' },
    { name: 'Paid' },
    { name: 'Overdue' },
  ];

  getPaymentCollection() {
    this.paymentService.getPaymentCollections(this.pageRequest,this.CustomerCode,this.selectedStatus.name).subscribe({
      next: (data: any) => {
        this.list = data.paymentCollection;
        // console.log(data.paymentCollection);
      },
      error: error => {
        console.log(error);
      }
    })
  }


  onStatusChange() {
    this.getPaymentCollection();
  }

  loadPaymentCollection(event: any) {
    this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
    this.getPaymentCollection();
  }

}
